export const SolidButtonStyles = {
    baseStyles : "w-full bg-iw-primary text-center items-center text-iw-text font-bold text-sm px-6 py-3 rounded-lg shadow text-white mr-1"
}